// Charge la base commune
import 'bootstrap/js/dist/scrollspy'

// Styles librairies
import './js/libs/slick-1.8.1/slick/slick.css'

// Styles custom
import './scss/pages/home'

// Scripts librairies
import './js/libs/slick-1.8.1/slick/slick.js'

require('./common.js')

// Contact Form
async function getContactForm ($f) {
  import('./js/components/contact-form.js').then(() => {
    $f.load(false)
  })
}

// Carousels
async function getSwiper ($f) {
  import('./js/components/swiper.js').then(() => {
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // ancre
  $('.scroll').each(function () {
    const $this = $(this)
    $this.on('click', function (e) {
      const t = $(e.target).is('a') ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($this.length > 0) {
        $('html, body').animate(
          {
            scrollTop: $(t).offset().top + 5
          },
          800
        )
      }
    })
  })

  // banner img slide js part
  $('.banner-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: false,
    prevArrow: '.slidPrv',
    nextArrow: '.slidNext',
    arrows: true,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 2000,
    fade: true,
    cssEase: 'linear'
  })

  // market slide js
  // $('.realisations').slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 3,
  //   autoplay: true,
  //   autoplaySpeed: 3000,
  //   speed: 2000,
  //   arrows: false,
  //   centerMode: true,
  //   centerPadding: '0px',
  //   focusOnSelect: true,
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     }, {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2
  //       }
  //     }, {
  //       breakpoint: 577,
  //       settings: {
  //         slidesToShow: 1,
  //         centerMode: false,
  //         slidesToScroll: 1,
  //         fade: true,
  //         cssEase: 'linear'
  //       }
  //     }
  //   ]
  // })

  // market slide js
  /*
  $('.market-main').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    focusOnSelect: true,
    // infinite: true,
    swipeToSlide: true,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 577,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 321,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  })
  */

  // gestion du formulaire de contact
  const $f = $('.contact-form')
  if ($f.length) {
    $f.waypoint(
      function () {
        $f.load()
        getContactForm($f)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }

  // gestion des filiales
  const $subs = $('.subsidiaries-carousel')
  if ($subs.length) {
    $subs.waypoint(
      function () {
        $subs.load()
        getSwiper($subs)
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }
})
